import Util from '../util/Util'; 
import FocusManagement from '../util/FocusManagement'; 

let modalWrap, modalContentWrap;
const closeSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7119 3.55005L3.62305 20.4499" stroke="#020303" stroke-width="6" stroke-miterlimit="10"/><path d="M3.62305 3.55005L20.7119 20.4499" stroke="#020303" stroke-width="6" stroke-miterlimit="10"/></svg>';

function open(el) {
  initElements();
  modalContentWrap.textContent = '';
  modalContentWrap.append(el);

  modalWrap.style.display = null;
  Util.forceReflow(modalWrap);
}

function initElements() {
  if (modalWrap) { return modalWrap; }

  modalWrap = document.createElement('div');
  modalWrap.classList.add('nstModal__overlay');
  modalWrap.style.display = 'none';
  document.body.append(modalWrap);
  
  modalWrap.innerHTML = `<div class='nstModal__wrap'><div class='nstModal'>
    <button class='nstModal__closeButton' aria-label='${ window.Ccfi.vars.xlate.close }'>${ closeSvg }</button>
    <div class='nstModal__contentWrap'></div>
  </div></div>`;
  
  modalContentWrap = modalWrap.querySelector('.nstModal__contentWrap');
  
  modalWrap.querySelector('.nstModal__closeButton').addEventListener('click', closeModal);
}

function closeModal() {
  modalWrap.style.display = 'none';
}


export default { open };